module.exports = __webpack_public_path__ + "3adac7e38aa80815f5012fd56eed4a9c.png";